import type { NodeType, NodeStatus, Priority } from './node.types';
import type { LinkType, LinkIntensity } from './link.types';

export const EXPORT_FORMAT = 'stratmap-canvas';
export const EXPORT_VERSION = 3;

export interface ExportedNode {
  localId: string;
  type: NodeType;
  title: string;
  description?: string;
  status: NodeStatus;
  priority: Priority;
  tags?: string[];
  position: { x: number; y: number };
  budgetPlanned?: number | null;
  budgetSpent?: number | null;
  effortPlannedDays?: number | null;
  effortSpentDays?: number | null;
  progress?: number | null;
}

export interface ExportedLink {
  sourceLocalId: string;
  targetLocalId: string;
  type: LinkType;
  intensity: LinkIntensity;
  label?: string;
  description?: string;
}

export interface StratMapExport {
  format: typeof EXPORT_FORMAT;
  version: number;
  exportedAt: string;
  canvas: {
    name: string;
    description?: string;
  };
  nodes: ExportedNode[];
  links: ExportedLink[];
}
